import { DomainBase } from "./DomainBase";

export class ReasonClass extends DomainBase {
    constructor() {
        super();
        this.reason = '';
        this.shortReason = '';
        this.type = null;
    }
}